export interface LcAdminRole {
  id: number
  name: string
  description?: string | null
  isTemplate: boolean
  isDefault: boolean
  permissions: string[]
  userCount: number
  createdAt: string
  updatedAt: string
}

export interface LcAdminRoleRequest {
  name: string
  description?: string
  permissions: string[]
}

export interface LcRoleListResponse {
  roles: LcAdminRole[]
  templates: LcAdminRole[]
}

export interface LcAccount {
  userId: number
  email: string
  fullName?: string | null
  phoneNumber?: string | null
  createdAt?: string | null
  role: string
  status: string
  lcAdminRoleId?: number | null
  lcAdminRoleName?: string | null
}

export interface LcAccountCreateRequest {
  email: string
  fullName: string
  phoneNumber: string
  initialPassword: string
  lcAdminRoleId: number
}

export interface LcAccountUpdateRequest {
  fullName?: string
  email?: string
  phoneNumber?: string
  lcAdminRoleId?: number | null
  status?: string
}

// 역할 관리에 노출하는 실제 관리자 페이지 권한 (backend PAGE_PERMISSIONS와 동기 유지)
export const LC_ALL_PERMISSIONS: { key: string; label: string }[] = [
  { key: 'DASHBOARD', label: '대시보드' },
  { key: 'COACHING', label: '오늘 수업' },
  { key: 'CLASS', label: '클래스 관리' },
  { key: 'STUDENT', label: '원생 관리' },
  { key: 'CONTENT', label: '콘텐츠 관리' },
  { key: 'MALL', label: '깨봉몰' },
  { key: 'PERFORMANCE', label: '결제내역' },
  { key: 'ANNOUNCEMENT', label: '공지사항' },
  { key: 'INQUIRY', label: '문의하기' },
  { key: 'LIBRARY', label: '자료실' },
  { key: 'DEVICE', label: '기기 관리' },
  { key: 'CENTER_INFO', label: '센터 정보 관리' },
]

export const LC_PERMISSION_MENU_GROUPS: { key: string; label: string; permissions: string[] }[] = [
  { key: 'DASHBOARD', label: '대시보드 (홈)', permissions: ['DASHBOARD'] },
  { key: 'COACHING', label: '오늘수업 (홈)', permissions: ['COACHING'] },
  { key: 'CLASS', label: '클래스 관리', permissions: ['CLASS'] },
  { key: 'STUDENT', label: '원생 관리', permissions: ['STUDENT'] },
  { key: 'CONTENT', label: '콘텐츠 관리', permissions: ['CONTENT'] },
  { key: 'MALL', label: '깨봉몰', permissions: ['MALL'] },
  { key: 'PERFORMANCE', label: '결제 내역', permissions: ['PERFORMANCE'] },
  { key: 'ANNOUNCEMENT', label: '공지사항', permissions: ['ANNOUNCEMENT'] },
  { key: 'INQUIRY', label: '문의하기', permissions: ['INQUIRY'] },
  { key: 'LIBRARY', label: '자료실', permissions: ['LIBRARY'] },
  { key: 'DEVICE', label: '기기 관리', permissions: ['DEVICE'] },
  { key: 'CENTER_INFO', label: '센터 정보 관리', permissions: ['CENTER_INFO'] },
]
